export interface MagicLinkRequest {
  projectId: string;
  clientEmail: string;
  expiresIn: string;
}

export interface TimeLogRequest {
  projectId: string;
  taskId: string;
  duration: number;
  description: string;
  startTime?: string;
  endTime?: string;
}

export interface NotificationTestRequest {
  ruleId: string;
  channels: string[];
  recipients: string[];
  message: string;
}

export interface WebhookProcessRequest {
  webhookId: string;
  email: {
    from: string;
    subject: string;
    body: string;
  };
  mappings: Array<{
    taskId: string;
    taskTitle: string;
    keywords: string[];
    emailPattern: string;
  }>;
}

export const onboardingIntegrationClient = {
  async generateMagicLink(request: MagicLinkRequest): Promise<{ token: string; url: string }> {
    const response = await fetch('/api/onboarding/generate-magic-link', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Failed to generate magic link');
    }

    const data = await response.json();
    return {
      token: data.token,
      url: `${window.location.origin}/control-bridge/onboarding/${request.projectId}?token=${data.token}`
    };
  },

  async validateMagicToken(token: string): Promise<any> {
    const response = await fetch(`/api/onboarding/share/${token}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error('Invalid or expired token');
    }

    return await response.json();
  },

  async logTime(request: TimeLogRequest): Promise<void> {
    const response = await fetch('/api/onboarding/log-time', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Failed to log time');
    }
  },

  async updateTaskTimeSpent(taskId: string, timeSpent: number): Promise<void> {
    const response = await fetch(`/api/work-objects/${taskId}/time-spent`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ timeSpent }),
    });

    if (!response.ok) {
      throw new Error('Failed to update task time spent');
    }
  },

  async sendTestNotification(request: NotificationTestRequest): Promise<void> {
    const response = await fetch('/api/notifications/test', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Failed to send test notification');
    }
  },

  async processEmailWebhook(request: WebhookProcessRequest): Promise<any> {
    const response = await fetch('/api/webhooks/email/process', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Failed to process email webhook');
    }

    return await response.json();
  },

  async testWebhook(): Promise<void> {
    const response = await fetch('/api/webhooks/test', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error('Failed to test webhook');
    }
  }
};
